<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal' : 'entry-2-modal'">
            <label>{{'disenyo-etiquetas.etiqueta.nombreDisenyo' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal' : 'entry-2-modal'">
            <label>{{'disenyo-etiquetas.etiqueta.tipoConfeccion.titulo' | translate}} *</label>
            <app-filterable-list [itemsList]="tiposConfeccion" [selectedItem]="newEditForm.get('tipoConfeccion')" [placeHolder]="false"></app-filterable-list>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{disenyoEtiquetaId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event">
</app-toast>